module.exports = __webpack_public_path__ + "img/1F1E8-1F1E6.873808b9.svg";